<div class="header-container fx-layout-row fx-justify-start fx-align-center fx-gap-10">
  @if (meeting) {
    <div class="meeting-name-block page-title">
      <div>{{ meeting?.toString() }}</div>
    </div>
  }

  <div class="fx-flex"></div>
  <workflow-buttons
    [entityType]="EntityType.MEETING"
    [view]="ManualWorkflowViewEnum.SHEET"
    [selectedEntityIds]="[meeting?.id]">
  </workflow-buttons>
  <div id="meeting-menu" class="fx-layout-row">
    <restricted-icon-button
      [class]="'mdi mdi-dots-vertical sm'" [id]="'meeting-sheet-menu-button'" [matMenuTriggerFor]="menu"
      [preconditions]="accessManager.hasAccess(Permission.DELETE_MEETING)">
    </restricted-icon-button>
    <mat-menu #menu="matMenu">
      <restricted-menu-item (onClick)="deleteMeeting()" [id]="'delete-meeting-menu'"
                            [permissions]="[Permission.DELETE_MEETING]"
                            [preconditions]="true">
        {{ 'BUTTON.DELETE_MEETING' | translate }}
      </restricted-menu-item>
    </mat-menu>
  </div>
</div>
